module.exports = __webpack_public_path__ + "static/media/biglow-woodcraft4.2d2b7671.jpg";